import React from 'react';
import { Instagram, Youtube, Twitch, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
import StarField from './StarField';

const DiscordIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418Z"/>
  </svg>
);

const SocialsSection = () => {
  const socialLinks = [
    {
      name: 'Instagram',
      icon: Instagram,
      url: 'https://www.instagram.com/chilltimeandwatch/',
      color: 'hover:bg-pink-600',
    },
    {
      name: 'YouTube',
      icon: Youtube,
      url: 'https://www.youtube.com/@ChillTimeAndWatch',
      color: 'hover:bg-red-600',
    },
    {
      name: 'Twitch',
      icon: Twitch,
      url: 'https://www.twitch.tv/chilltimeandwatch/about',
      color: 'hover:bg-purple-600',
    },
  ];

  return (
    <section id="socials" className="py-24 bg-black relative overflow-hidden">
      <StarField density="sparse" />
      <div className="container mx-auto px-6 max-w-4xl relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-white mb-4 tracking-tight">
            Connect With Me
          </h2>
          <p className="text-gray-400 font-light">
            Follow my watch building journey across platforms
          </p>
        </div>

        {/* Social Links Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group bg-white/5 backdrop-blur-sm border border-white/10 p-8 flex flex-col items-center justify-center space-y-4 transition-all duration-300 hover:bg-white/10 hover:border-white/30 hover:shadow-[0_0_40px_rgba(255,255,255,0.15)] hover:-translate-y-1 ${social.color}`}
            >
              <social.icon className="w-12 h-12 text-white group-hover:scale-110 transition-transform duration-300" />
              <span className="text-white font-light">{social.name}</span>
              <ExternalLink className="w-4 h-4 text-white/60 group-hover:text-white transition-colors" />
            </a>
          ))}
        </div>

        {/* Discord CTA - Prominent */}
        <div className="relative">
          <div className="absolute inset-0 bg-white/5 blur-xl"></div>
          <div className="relative border-4 border-white p-12 text-center">
            <DiscordIcon className="w-16 h-16 text-white mx-auto mb-6" />
            <h3 className="text-3xl font-light text-white mb-4">
              Join the Watch Building Community
            </h3>
            <p className="text-gray-300 font-light mb-8 max-w-2xl mx-auto">
              Connect with fellow watch enthusiasts, share your builds, get feedback, and learn together. 
              Free membership available!
            </p>
            <a
              href="https://discord.gg/T8yG3KGex4"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button 
                size="lg" 
                className="bg-white text-black hover:bg-gray-200 font-light px-12 py-6 text-lg transition-all duration-300 hover:scale-105"
              >
                Join Discord Server
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialsSection;
